import { CategorySub, Hierarchy } from '@karakuri-web/faq-type'

export function toTopBreadcrumbs(
  hierarchies: Hierarchy[],
  current: Hierarchy,
  topTitle: string
): Required<Hierarchy>[] {
  return [
    { title: topTitle, link: '/' },
    ...(hierarchies || [])
      .filter(({ title }) => title)
      .map(link => ({ ...link, link: link.link || '/' })),
    current,
  ]
}

function findCategoryById(id: string, categories: readonly CategorySub[]): CategorySub | undefined {
  return categories.find(category => category.id === id)
}

function buildBreadcrumbs(
  category: CategorySub,
  categories: readonly CategorySub[],
  hierarchies: Required<Hierarchy>[]
): Required<Hierarchy>[] {
  const breadcrumbs = [...hierarchies]
  const parents = []
  let currentCategory = category

  while (currentCategory.parent) {
    const parentCategory = findCategoryById(currentCategory.parent, categories)
    if (!parentCategory) break
    parents.unshift({
      title: parentCategory.title || '',
      link: `/category/${parentCategory.id}`,
    })
    currentCategory = parentCategory
  }

  breadcrumbs.splice(1, 0, ...parents)
  breadcrumbs.splice(1 + parents.length, 0, {
    title: category.title || '',
    link: `/category/${category.id}`,
  })

  return breadcrumbs
}

/**
 * relatedCategoriesから複数パンくずを生成する（全経路表示）
 * 各カテゴリごとに独立したパンくずを生成
 *
 * @param relatedCategories - 関連カテゴリ情報
 * @returns パンくずリストの配列（二次元配列）
 */
export function toAllBreadcrumbs(
  hierarchies: Required<Hierarchy>[],
  relatedCategories: readonly CategorySub[]
): Required<Hierarchy>[][] {
  if (!relatedCategories || relatedCategories.length === 0) {
    return [hierarchies]
  }

  const result: Required<Hierarchy>[][] = []

  relatedCategories.forEach(category => {
    if (!category.isParent) {
      const newHierarchies = buildBreadcrumbs(category, relatedCategories, hierarchies)
      result.push(newHierarchies)
    }
  })

  return result
}

export function traverse(
  category: CategorySub,
  dictionary: Record<string, CategorySub>,
  hierarchies: { title: string; id: string }[] = []
): { title: string; id: string }[] {
  if (!dictionary || !category) {
    return hierarchies
  }
  const c = dictionary[category.id || '']
  if (!c || !c.parent) {
    return hierarchies
  }
  const parent = dictionary[c.parent]
  if (!parent) {
    return hierarchies
  }
  return traverse(parent, dictionary, [
    ...hierarchies,
    { id: parent.id || '', title: parent.title || '' },
  ])
}
